import React, { Component } from 'react'


//material-ui
import withStyles from "@material-ui/core/styles/withStyles";
import FormLabel from "@material-ui/core/FormLabel";
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
//component
// import PerfectScrollbar from "perfect-scrollbar";
//dashboard-pro
import GridContainer from "../components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CommonHttp from 'global/CommonHttp';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import TextField from '@material-ui/core/TextField';
import { checkOrgnizationCode } from '../global/utils'
//css
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import { replaceSpaces } from '../global/utils.js';

// import {roseColor} from "assets/jss/material-dashboard-pro-react.jsx";

let ps;
class Contactperson extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formObj: props.formObj,
            disableCodeBtn: false,
            codeText: '获取验证码',
            imgCodeUrl: " ",
            imgDisplay: false
        }
        // this.onInputChange = this.onInputChange.bind(this);
        this.selectGender = this.selectGender.bind(this);
        this.selectFemale = this.selectFemale.bind(this);
        this.selectMale = this.selectMale.bind(this);
        this.sendCode = this.sendCode.bind(this);
    }

    selectMale() {
        console.log('Male');
        this.props.changeFun('sex', 1);
    }

    selectFemale() {
        console.log('Female');
        this.props.changeFun('sex', 2);
    }
    /** 统一信用代码 */
    changeCode(e) {
        const strArr = e.target.value.match(/[A-Z0-9]/g)
        const val = strArr ? strArr.join('') : '';
        this.props.changeFun('orgnizationCode', val);
    }

    selectGender(event) {
        console.log(event);
    }

    getImgCode() {
        const { formObj } = this.props;
        this.setState({ imgCodeUrl: `/shared-base-data/basic/v1/register/pic-verificationCode/${formObj.mobile}?${+new Date()}` })
    }
    onInputChange(keyWords, value) {
        let el = document.getElementById(keyWords);
        if (el && el.value && el.value !== this.state.formObj[keyWords]) {
            let curValue = replaceSpaces(el.value);
            this.props.changeFun(keyWords, curValue);
        }
    }

    imgHandleClose() {
        const { formObj } = this.props;
        console.log(formObj.picVerificationCode);
        if (!/^\d{4}$/.test(formObj.picVerificationCode)) {
            this.props.openSnackbar('请输入正确的图片验证码', 'warning');
        }
        else {
            //首先按钮灰化
            this.setState({
                disableCodeBtn: true,
                codeText: '60秒后才能发送',
                imgDisplay: false
            })
            //让按钮进入倒计时
            let tempCode = 60
            let intId = setInterval(() => {
                this.setState({ codeText: `${--tempCode}秒后才能发送` });
                if (tempCode === 0) {
                    clearInterval(intId);
                    this.setState({
                        disableCodeBtn: false,
                        codeText: '获取验证码'
                    })
                }
            }, 1000);
            //发送请求
            CommonHttp.get(
                `/register/verificationCode?mobile=${formObj.mobile}&supplierName=${formObj.supplierName}&orgnizationCode=${formObj.orgnizationCode}&picVerificationCode=${formObj.picVerificationCode}`
            ).then(res => {
                //若请求成功，不做其他操作

                this.props.openSnackbar('请求成功，请留意短信', 'success');
            }, err => {
                //请求失败，重置倒计时，可以即刻重新发送
                clearInterval(intId);
                this.setState({
                    disableCodeBtn: false,
                    codeText: '获取验证码'
                })
                this.props.openSnackbar(err);
            })
        }

    }

    sendCode() {
        const { formObj } = this.props;
        if (!formObj.supplierName || !formObj.orgnizationCode) {
            //校验公司名与组织机构号
            this.props.openSnackbar('必须先输入公司名称与组织机构代码', 'warning');
        } else if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(formObj.mobile))) {
            this.props.openSnackbar('请输入正确手机号', 'warning');
        }
        else {
            this.setState({
                imgDisplay: true,
                imgCodeUrl: `/shared-base-data/basic/v1/register/pic-verificationCode/${formObj.mobile}?${+new Date()}`
            })
        }
    }

    // componentDidMount() {
    //     ps = new PerfectScrollbar('#contactFormContainer', {
    //         suppressScrollX: true,
    //         suppressScrollY: false
    //     });
    // }

    componentWillUnmount() {
        ps.destroy();
    }


    render() {
        const { classes } = this.props;
        const { imgCodeUrl, imgDisplay } = this.state;
        return (
            <div id="contactFormContainer">
                <GridContainer>
                    <GridItem xs={12} sm={12} md={4}>
                        <FormLabel className={classes.labelHorizontal}>
                            <span className={classes.validationSymbol}>*</span>公司名称
                        </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={5}>
                        <CustomInput formControlProps={{ fullWidth: true }} id='supplierName'
                            inputProps={{
                                placeholder: '请填写组织机构名称',
                                disabled: false,
                                value:this.props.formObj.supplierName,
                                onChange: (e) => this.props.changeFun('supplierName', replaceSpaces(e.target.value)),
                                onBlur:(e)=>{
                                    this.props.checkSupplierName(e.target.value)
                                }
                            }} />
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={4}>
                        <FormLabel className={classes.labelHorizontal}>
                            <span className={classes.validationSymbol}>*</span>组织机构代码
                        </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={5}>
                        <CustomInput formControlProps={{ fullWidth: true }} id='orgnizationCode'
                            inputProps={{
                                placeholder: '请输入9位组织机构代码或18位统一社会信用代码', disabled: false,
                                defaultValue: (this.state.formObj.orgnizationCode),
                                // onBlur: this.onInputChange.bind(this, 'orgnizationCode')
                                value: (this.props.formObj.orgnizationCode),
                                onChange: (e) => this.changeCode(e),
                                onBlur: (e) => checkOrgnizationCode(e.target.value, this.props.formObj.supplierName, this.props.openSnackbar)
                            }
                            } />
                    </GridItem>
                    <GridItem xs={8} sm={8} md={3}>
                        <FormLabel style={{ float: 'none' }} className={classes.labelHorizontal}>注：个体工商户此处请填写营业执照号。</FormLabel>
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={4}>
                        <FormLabel className={classes.labelHorizontal}>
                            <span className={classes.validationSymbol}>*</span>手机号
                        </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={5}>
                        <CustomInput formControlProps={{ fullWidth: true }} id='mobile'
                            inputProps={{
                                disabled: false, defaultValue: (this.state.formObj.mobile),
                                onBlur: this.onInputChange.bind(this, 'mobile')
                            }} />
                    </GridItem>

                </GridContainer>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={4}>
                        <FormLabel className={classes.labelHorizontal}>
                            <span className={classes.validationSymbol}>*</span>手机验证码
                        </FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={5}>
                        <CustomInput formControlProps={{ fullWidth: true }} id='verificationCode'
                            inputProps={{ disabled: false, defaultValue: (this.state.formObj.verificationCode), onBlur: this.onInputChange.bind(this, 'verificationCode') }} />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                        <Button disabled={this.state.disableCodeBtn} style={{ marginTop: '17px' }}
                            size='sm' color="info" onClick={() => this.sendCode()}>{this.state.codeText}</Button>
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={4}>
                        <FormLabel className={classes.labelHorizontal}><span className={classes.validationSymbol}>*</span>姓名</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={5}>
                        <CustomInput formControlProps={{ fullWidth: true }} id='realName'
                            inputProps={{ disabled: false, defaultValue: (this.state.formObj.realName), onBlur: this.onInputChange.bind(this, 'realName') }} />
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={4}>
                        <FormLabel className={classes.labelHorizontal} style={{ paddingTop: '29px' }}>性别</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={5}>
                        <FormControlLabel style={{ marginTop: '16px' }}
                            value="male" label="男"
                            control={<Radio onChange={this.selectMale} checked={this.props.formObj.sex === 1} color="primary" />}
                            labelPlacement="start" />
                        <FormControlLabel style={{ marginTop: '16px' }}
                            value="female" label="女"
                            control={<Radio onChange={this.selectFemale} checked={this.props.formObj.sex === 2} color="primary" />}
                            labelPlacement="start" />
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={4}>
                        <FormLabel className={classes.labelHorizontal}><span className={classes.validationSymbol}>*</span>密码</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={5}>
                        <CustomInput formControlProps={{ fullWidth: true }} id='password'
                            inputProps={{ type: "password", disabled: false, defaultValue: (this.state.formObj.password), onBlur: this.onInputChange.bind(this, 'password') }} />
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={4}>
                        <FormLabel className={classes.labelHorizontal}><span className={classes.validationSymbol}>*</span>确认密码</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={5}>
                        <CustomInput formControlProps={{ fullWidth: true }} id='comfirmPassword'
                            inputProps={{ type: "password", disabled: false, defaultValue: (this.state.formObj.comfirmPassword), onBlur: this.onInputChange.bind(this, 'comfirmPassword') }} />
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={4}>
                        <FormLabel className={classes.labelHorizontal}><span className={classes.validationSymbol}>*</span>邮箱</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={5}>
                        <CustomInput formControlProps={{ fullWidth: true }} id='email'
                            inputProps={{ disabled: false, defaultValue: (this.state.formObj.email), onBlur: this.onInputChange.bind(this, 'email') }} />
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={4}>
                        <FormLabel className={classes.labelHorizontal}>QQ(可选)</FormLabel>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={5}>
                        <CustomInput formControlProps={{ fullWidth: true }} id='qq'
                            inputProps={{ disabled: false, defaultValue: (this.state.formObj.qq), onBlur: this.onInputChange.bind(this, 'qq') }} />
                    </GridItem>
                </GridContainer>
                <Dialog
                    open={imgDisplay} maxWidth='xs'
                    fullWidth={true} keepMounted
                    onClose={() => { this.setState({ imgDisplay: false }) }}>
                    <DialogTitle id="customized-dialog-title" onClose={() => { this.setState({ imgDisplay: false }) }}>
                        输入图片验证码
                    </DialogTitle>
                    <DialogContent style={{ height: '160px', overflow: 'auto', display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center' }}>
                        <div style={{ flexBasis: '100%', display: 'flex', justifyContent: 'center' }}>
                            <img src={imgCodeUrl} onClick={() => { this.getImgCode() }} height="40x" width="100px" alt="加载验证失败" />
                        </div>
                        <TextField
                            required
                            id="picVerificationCode"
                            label="输入图片验证码(4位数字)"
                            inputProps={{ onBlur: this.onInputChange.bind(this, 'picVerificationCode') }}
                            variant="outlined"
                        />
                    </DialogContent>
                    <Button
                        color="info"
                        style={{ width: '30%', alignSelf: 'center', marginBottom: '20px' }}
                        onClick={() => { this.imgHandleClose() }}  >
                        确定
                    </Button>
                </Dialog>
            </div>
        )
    }
}

// export default withStyles(regularFormsStyle)(Contactperson);
export default withStyles(regularFormsStyle)(Contactperson);